import { render, staticRenderFns } from "./activityEditExam.html?vue&type=template&id=5df63a7e&scoped=true&external"
import script from "./activityEditExam.vue?vue&type=script&lang=js"
export * from "./activityEditExam.vue?vue&type=script&lang=js"
import style0 from "./activityEditExam.vue?vue&type=style&index=0&id=5df63a7e&prod&lang=css"
import style1 from "./activityEditExam.css?vue&type=style&index=1&id=5df63a7e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df63a7e",
  null
  
)

export default component.exports